<template>
  <div class="questionnaire">
    <div class="mainInfoQuestionnaire">
      <div class="girlPhoto">
        <a v-if="linkHref" :href="linkHref">
          <img v-if="girlData.photos && girlData.photos.length > 0" :src="girlData.photos[0].url" />
          <img v-else src="../assets/img/noPhoto.svg" />
        </a>
        <template v-else>
          <img v-if="girlData.photos && girlData.photos.length > 0" :src="girlData.photos[0].url" :id="girlData._id" @click="$emit('photo-click', $event)" style="cursor: pointer" />
          <img v-else src="../assets/img/noPhoto.svg" :id="girlData._id" @click="$emit('photo-click', $event)" style="cursor: pointer" />
        </template>
      </div>
      <div class="infoGirl">
        <div class="girlName">
          {{ girl.fullName }}
          <div class="verify-wrapper">
            <img v-if="girl.verified" src="../assets/icons/verify.svg" @mouseenter="isGirlVerify = true" @mouseleave="isGirlVerify = false" />
            <div class="verifyPopUp">
              <p>Эта модель успешно<br />прошла верификацию</p>
            </div>
          </div>
        </div>
        <!-- <p>{{ cityName }}</p> -->
        <div class="featuresGirl">
          <div class="pinkFeatures">
            <div class="pinkFeature">
              <span class="pinkFeatureLabel">Возраст</span>
              <span class="pinkFeatureValue">{{ girlData.age }} {{ getPluralForm(girlData.age) }}</span>
            </div>
            <div class="pinkFeature">
              <span class="pinkFeatureLabel">Грудь</span>
              <span class="pinkFeatureValue">{{ girlData.boobsSize }}</span>
            </div>
            <div class="pinkFeature">
              <span class="pinkFeatureLabel">Вес</span>
              <span class="pinkFeatureValue">{{ girlData.weight }} кг</span>
            </div>
            <div class="pinkFeature">
              <span class="pinkFeatureLabel">Рост</span>
              <span class="pinkFeatureValue">{{ girlData.height }} см</span>
            </div>
          </div>
          <div class="blueFeatures">
            <div class="blueFeature" v-if="girlData.individual">Индивидуалка</div>
            <div class="blueFeature" v-if="girlData.escort">Эскорт</div>
            <div class="blueFeature" v-if="girlData.slut">Проститутка</div>
            <div class="blueFeature" v-if="girlData.massage">Массажистка</div>
            <div class="blueFeature" v-if="girlData.premium">Премиум</div>
            <div class="blueFeature" v-if="girlData.elite">Элитная</div>
          </div>
        </div>
      </div>
    </div>
    <div class="priceGirl">
      <div class="hourRent">
        <div class="infoHour infoHourPink">
          <img src="../assets/icons/clock1h.svg" class="infoHourIcon" />
          <div class="infoHourLabel">1 час</div>
          <div class="priceSum">{{ formatPrice(girlData.oneHourPrice) }}<span>₽</span></div>
        </div>
        <div class="infoHour infoHourPink">
          <img src="../assets/icons/clock2h.svg" class="infoHourIcon infoHourIconWide" />
          <div class="infoHourLabel">2 часа</div>
          <div class="priceSum">{{ formatPrice(twoHourPriceValue) }}<span>₽</span></div>
        </div>
        <div class="infoHour infoHourNight">
          <img src="../assets/icons/moonNight.svg" class="infoHourIcon" />
          <div class="infoHourLabel infoHourLabelNight">ночь</div>
          <div class="priceSum">{{ formatPrice(girlData.nightPrice) }}<span>₽</span></div>
        </div>
      </div>
      <slot name="action">
        <a v-if="buttonLinkHref" :href="buttonLinkHref">
          <button class="reservationButton" @click="$emit('reserve-click', $event)">Забронировать</button>
        </a>
        <button v-else class="reservationButton" :id="girlData._id" @click="$emit('reserve-click', $event)">Забронировать</button>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "GirlCard",
  props: {
    girl: {
      type: Object,
      required: true,
    },
    // Ключ для вложенных данных (например 'girlId' для истории заказов)
    girlDataKey: {
      type: String,
      default: null,
    },
    cityName: {
      type: String,
      default: "",
    },
    // Ссылка на фото (если null — фото не оборачивается в <a>)
    linkHref: {
      type: String,
      default: null,
    },
    // Ссылка для кнопки "Забронировать"
    buttonLinkHref: {
      type: String,
      default: null,
    },
  },
  emits: ["photo-click", "reserve-click"],
  data() {
    return {
      isGirlVerify: false,
    };
  },
  computed: {
    // Возвращает объект с данными девушки (girl или girl.girlId для истории)
    girlData() {
      if (this.girlDataKey && this.girl[this.girlDataKey]) {
        return this.girl[this.girlDataKey];
      }
      return this.girl;
    },
    twoHourPriceValue() {
      if (this.girlData.twoHourPrice != null) {
        return this.girlData.twoHourPrice;
      }
      return this.girlData.oneHourPrice * 2;
    },
  },
  methods: {
    getPluralForm(number) {
      let forms = ["год", "года", "лет"];
      number = Math.abs(number) % 100;
      const lastDigit = number % 10;
      if (number > 10 && number < 20) return forms[2];
      if (lastDigit === 1) return forms[0];
      if (lastDigit >= 2 && lastDigit <= 4) return forms[1];
      return forms[2];
    },
    formatPrice(value) {
      if (value == null) return "0";
      return Number(value).toLocaleString("ru-RU");
    },
  },
};
</script>

<style scoped>
.questionnaire {
  background-color: #fbfbfb;
  border: 1px solid #f4f4f4;
  border-radius: 10px;
  padding: 20px;
  gap: 10px;
  display: flex;
  flex-direction: column;
}
.mainInfoQuestionnaire {
  display: flex;
  height: 80%;
  gap: 20px;
}
.girlPhoto {
  width: 100%;
  height: 100%;
}
.girlPhoto img {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  object-fit: cover;
}
.infoGirl {
  width: 70%;
}
.girlName {
  font-size: 16px;
  font-weight: 600;
  display: flex;
  gap: 5px;
  align-items: center;
  position: relative;
  margin-bottom: 1rem;
}

.verifyPopUp {
  position: absolute;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #2f2f2f;
  color: #fff;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s;
  z-index: 10;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.verifyPopUp p {
  display: flex;
  align-items: center;
  margin-bottom: 0 !important;
  font-size: 14px;
  font-weight: 500;
}

.verify-wrapper:hover .verifyPopUp {
  opacity: 1;
}
.infoGirl p:nth-child(2) {
  font-size: 14px;
  margin-bottom: 10px;
}
.priceGirl {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.featuresGirl {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 10px;
}
.pinkFeatures {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}
.blueFeatures {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.pinkFeature {
  background-color: #ff898926;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 6px 10px;
  text-align: center;
}
.pinkFeatureLabel {
  font-size: 14px;
  font-weight: 600;
  color: #f78383;
}
.pinkFeatureValue {
  font-size: 14px;
  font-weight: 700;
  color: #8f5555;
  white-space: nowrap;
}
.blueFeature {
  background-color: #89bfff26;
  color: #89bfff;
  font-size: 14px;
  font-weight: 600;
  border-radius: 10px;
  padding: 5px 10px;
}
.hourRent {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 2px;
}
.hourRent > div:nth-child(1) {
  border-radius: 0.8rem 0 0 0.8rem;
}
.hourRent > div:nth-child(2) {
  border-radius: 0;
}
.hourRent > div:nth-child(3) {
  border-radius: 0 0.8rem 0.8rem 0;
}
.infoHour {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 12px;
  padding: 10px 12px;
  min-height: 70px;
  position: relative;
  overflow: hidden;
}
.infoHourPink {
  background-color: #ff767f;
}
.infoHourNight {
  background-color: #1b4365;
}
.infoHourLabel {
  background-color: #ffffff;
  color: #ff767f;
  font-size: 12px;
  font-weight: 700;
  border-radius: 20px;
  padding: 3px 12px;
  text-transform: lowercase;
  width: fit-content;
  position: relative;
  z-index: 1;
}
.infoHourLabelNight {
  color: white;
  background-color: #3871a1;
  font-size: 13px;
  letter-spacing: 0.5px;
}
.infoHourIcon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  width: 1.5vw;
  height: auto;
}
.infoHourIconWide {
  width: 2vw;
}
.priceSum {
  display: flex;
  align-items: baseline;
  gap: 2px;
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  position: relative;
  z-index: 1;
}
.priceSum span {
  font-family: "Noto Sans";
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
}
.reservationButton {
  background-color: #2f2f2f;
  border-radius: 10px;
  border: 1px solid #2f2f2f;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-weight: 600;
  color: #ffffff;
  padding: 10px;
  cursor: pointer;
}
@media (max-width: 1490px) {
  .pinkFeature span {
    white-space: nowrap;
  }
}

@media (max-width: 1200px) {
  .priceSum {
    font-size: 14px;
  }
  .infoHourLabel {
    padding: 2px 7px;
  }
}
@media (max-width: 700px) {
  .infoHourIcon {
    width: 6vw;
  }
  .girlPhoto {
    width: 70%;
  }
}
</style>
